module.exports = __webpack_public_path__ + "8e865c18e98771ddfcb3485f132e154f.MP3";